module.exports = __webpack_public_path__ + "static/media/logo_vietinbank.6c370ded.svg";